<mat-toolbar color="primary"  class="pad">
<!--  <span>Watchlist</span>-->
  <span (click)="goHome()" style="cursor: pointer">Watchlist</span>
  <span class="spacer"></span>
  <app-search></app-search>
</mat-toolbar>
